<template>
  <form class="kompa-product-form uk-form-stacked" @submit.prevent="submit">
    <text-input ref="name" :label="$t('fields.name') + '*'" v-model="form.model.name" :errors="form.errors.name"
      :disabled="!isEditable" />
    <keyword-list-input :disabled="!isEditable" :errors="form.errors.eanList" :label="$t('fields.eanList')"
      v-model="form.model.eanList" />

    <product-family-combobox v-model="form.model.family" :label="$t('fields.family')" :errors="form.errors.family"
      :disabled="!isEditable" />

    <text-input ref="brand" :label="$t('fields.brand') + '*'" v-model="form.model.brand" :errors="form.errors.brand"
      :disabled="!isEditable" />

    <text-input ref="manufacturer_part_number" :label="$t('fields.manufacturerPartNumber')"
      v-model="form.model.manufacturerPartNumber" :errors="form.errors.manufacturerPartNumber"
      :disabled="!isEditable" />

    <text-input ref="priority" type="number" :min="0" :max="100" :step="1" :label="$t('fields.priority')"
      v-model.number="form.model.priority" :errors="form.errors.priority" :disabled="!isEditable" />

    <keyword-list-input :disabled="!isEditable" :errors="form.errors.compatibleAppVersions"
      :label="$t('fields.compatibleAppVersions')" v-model="form.model.compatibleAppVersions"
      :options="['MSHPro', 'MSHFree', 'MZAPro', 'MZABasic']" />

    <keyword-list-input :disabled="!isEditable" :errors="form.errors.compatibleBaseStations"
      :label="$t('fields.compatibleBaseStations')" v-model="form.model.compatibleBaseStations"
      :options="['1', '2', '3', '4']" />

    <checkbox :disabled="!isEditable" :errors="form.errors.connectionRequired" :label="$t('fields.connectionRequired')"
      ref="primaryInput" v-model="form.model.connectionRequired" />
    <text-input ref="connectionRequiredLabel" :label="$t('fields.connectionRequiredLabel')"
      v-model="form.model.connectionRequiredLabel" :errors="form.errors.connectionRequiredLabel"
      :disabled="!isEditable" />
    <text-input ref="extension" :label="$t('fields.extension')" v-model="form.model.extension"
      :errors="form.errors.extension" :disabled="!isEditable" />

    <fieldset class="uk-fieldset uk-margin-medium-top">
      <legend class="uk-legend uk-margin">{{ $t('fieldsets.media') }}</legend>

      <attachment-manager :disabled="!isEditable" attachment-type="MEDIA_OBJECT" v-model="form.model.attachments" />
    </fieldset>


    <submit-button type="primary" :disabled="!isSubmittable" />
    <cancel-button />


  </form>
</template>

<script>
import AttachmentInput from '@/components/AttachmentInput';
import AttachmentManager from '@/components/AttachmentManager';
import Form from '@/mixins/LegacyForm';
import KeywordListInput from '@/components/KeywordListInput';
import Checkbox from '@/components/Checkbox';
import ProductFamilyCombobox from '@/components/ProductFamilyCombobox';

export default {
  name: 'kompa-product-form',
  components: {
    AttachmentInput,
    AttachmentManager,
    KeywordListInput,
    Checkbox,
    ProductFamilyCombobox,
  },
  mixins: [
    Form({
      name: { required: true },
      priority: { required: false },
      eanList: { required: false },
      brand: { required: true },
      manufacturerPartNumber: { required: false },
      compatibleAppVersions: { required: false },
      compatibleBaseStations: { required: false },
      connectionRequired: { required: false },
      connectionRequiredLabel: { required: false },
      extension: { required: false },
      attachments: { required: false },
      heroImageAttachment: { required: false },
      family: { required: false },
    }),
  ],
  mounted() {
    this.$refs.name.focus();
  },
};
</script>



// WEBPACK FOOTER //
// KompaProductForm.vue?192403cc